import qs from 'qs';

const merge = (path: string, queryString: string) =>
  path + (path.includes('?') ? '&' : '?') + queryString;

const applyPathParams = <QQ extends Record<string, any> = any>(
  path: string | ((query: QQ) => string),
  params: QQ,
) => {
  if (typeof path === 'string') {
    return merge(path, qs.stringify(params));
  }

  const paramsMap = new Map(Object.entries(params));
  const proxy = {} as QQ;

  Object.defineProperties(
    proxy,
    Object.fromEntries(
      Object.entries(params).map(([key, value]) => [
        key,
        {
          get: () => {
            paramsMap.delete(key);

            return value;
          },
        },
      ]),
    ),
  );

  const appliedPath = path(proxy);
  const withoutUtilized = Object.fromEntries(paramsMap.entries());

  return merge(appliedPath, qs.stringify(withoutUtilized));
};

export { applyPathParams };
